import { StrictMode, Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "./styles/index.css";

// Routes chargées à la demande (code-splitting par page).
const Catalogue = lazy(() =>
  import("./pages/Catalogue.tsx").then((m) => ({ default: m.Catalogue })),
);
const PageExperience = lazy(() =>
  import("./pages/PageExperience.tsx").then((m) => ({
    default: m.PageExperience,
  })),
);

const router = createBrowserRouter(
  [
    { path: "/", element: <Catalogue /> },
    { path: "/experience/:id", element: <PageExperience /> },
  ],
  // Sous GitHub Pages, l'app vit sous /maths-physic-Visuals/ ; en dev, sous /.
  { basename: import.meta.env.BASE_URL.replace(/\/$/, "") || "/" },
);

const racine = document.getElementById("root");
if (!racine) throw new Error("Élément racine #root introuvable.");

createRoot(racine).render(
  <StrictMode>
    <Suspense fallback={null}>
      <RouterProvider router={router} />
    </Suspense>
  </StrictMode>,
);
